(function($, visceral) {

    if(visceral == null) {
        window.visceral = visceral = {}; 
    }
    visceral.work_site = {};

    $(function () {
        init();
    });
    
    
    function init() {

        // scale range refers to the beginning and final tranform:scale() values.
        // kill spot refers to the point at which scrolling into the element when the animations/transformation 
        //   is killed/aborted and locked in place. Set to a negative number to not have a kill spot

        let malawi = $('.work-site--id-malawi');
        if(malawi.length) {
            new WorkSite(malawi[0], { scale: {range: [1,20], max: 8}, kill_spot: 250 })
        }

        let bangladesh = $('.work-site--id-bangladesh');
        if(bangladesh.length) {
            new WorkSite(bangladesh[0], { scale: { range: [1,20], max: 8 }, kill_spot: 150, trigger_offset: "5%" })
        }

        let others = $('.work-site').not(malawi).not(bangladesh);
        if(others.length) {
            others.each(function() {
                new WorkSite(this, { scale: { range: [1,20], max: 8 }, kill_spot: 250 })
            })
        }

        $('.work-site__item').on('click touch', function() {
            $(this).toggleClass('work-site__item--active');
            $('.work-site__item--active').not(this).removeClass('work-site__item--active');
        })
    }

    function WorkSite(element, args) {
        let klass = this;

        klass.scale = args.scale;
        klass.kill_spot = args.kill_spot;
        klass.element = element;
        klass.$element = $(element);
        klass.foreground = klass.$element.find('.work-site__foreground-image');
        klass.killed = false;
        
        if(args.trigger_offset && typeof(args.trigger_offset) == 'string' && args.trigger_offset.indexOf("%")) {
            klass.trigger_offset = function() { return window.innerHeight * parseInt(args.trigger_offset)/100; }
        }
        else {
            klass.trigger_offset = function() { return parseInt(args.trigger_offset) || 0; }
        }

        klass.on_scroll = function() {
            //console.log('is_on_screen', klass.is_on_screen())

            //if the element is on the screen and the animation has not been killed,  calcluate if the kill spot has been hit and set the styles 
            if(klass.is_on_screen() && !klass.killed) {

                //if a kill spot has been defined, calculate if it has been hit
                if(klass.kill_spot && klass.kill_spot>=0) {
                    let px = klass.px_into_element();
                    if(px >= klass.kill_spot) {

                        // if the kill spot has been hit, unhind the event handler and set the flag
                        // NOTE: JB 9/16 - I removed the unbinding because I still want the scroll position to auto-close the windows on mobile if you scroll away
                        klass.killed = true;
                        klass.$element.addClass('work-site--show-content')
                        //console.log('killing and unbinding');
                        //$(window).unbind('scroll', klass.on_scroll);
                    }
                }

                //set the scroll animation styles/transformation
                let progress = klass.scroll_progress();
                klass.set_element_progress(progress);
            } else {
              $('.work-site__item--active').removeClass('work-site__item--active');
            }
        }

        $(window).scroll(klass.on_scroll);

        /*
         * Calculates the point at which the work-item element is considered to be on the page
         */
        klass.trigger_point = function() {
            let win_top = klass.scroll_position();
            let win_height = window.innerHeight;

            let y = win_top + win_height/2 + klass.trigger_offset();
            //console.log(y);
            return y;
        }

        /* 
         * Gets the scrollTop of the page
         */
        klass.scroll_position = function() {
            return $('html').scrollTop() || $('body').scrollTop();
        }

        /*
         * Calculates if the work-item element has been scrolled into the viewport
         */
        klass.is_on_screen = function() {
            let el_top = klass.$element.offset().top;
            let el_height = klass.$element.height();
            let el_bot = el_top + el_height;

            let trigger_point = klass.trigger_point() 

            //console.log(el_top, trigger_point, el_bot);
            
            return (el_top <  trigger_point) && (trigger_point < el_bot);
        }

        /* 
         * Calculates the number of pixels that the window has scrolled into the work-item element
         */
        klass.px_into_element = function() {
            let el_top = klass.$element.offset().top;
            let trigger_point = klass.trigger_point() 
            let px_into_element = trigger_point - el_top;
            return px_into_element;
        }

        /* 
         * Returns the percentage that the window has scrolled through the work-item element
         */
        klass.scroll_progress = function() {
            let el_height = klass.$element.height();
            let px = klass.px_into_element();
            let percentage = px / el_height;
            return Math.min(Math.max(0, percentage), 1);
        }

        /*
         * Defines the easing function that applies to the foreground scale
         */
        klass.easing = function(x) {
            return -0.5 * Math.cos(Math.PI * x) + 0.5;
        }

        /*
         * Maps a percentage into a range of values
         */
        klass.map_to_range = function(progress, range) {
            let begin = range[0];
            let end = range[1];
            return ((end - begin) * progress) + begin;
        }

        /*
         * Applies the transformation styles to the foreground based on the easing and the scroll position
         */
        klass.set_element_progress = function(progress) { 
            let easing_progress = klass.easing(progress);
            let scale = klass.map_to_range(easing_progress, klass.scale.range);

            if (klass.scale && klass.scale.min) {
                scale = Math.max(klass.scale.min, scale);
            }

            if (klass.scale && klass.scale.max) {
                scale = Math.min(klass.scale.max, scale);
            }
            
            //console.log('set element', progress, easing_progress, scale);
            klass.foreground.css({
                transform: 'translate(-50%, -56%)',
                width: (scale * 5) + '%',
            });
        }
    }

})(jQuery, window.visceral);


// WEBPACK FOOTER //
// ./scripts/work-site.js